import React from 'react'
import MicroConferenceVideoWrapper from "../../../CertificateDashboard/MicroConferenceVideoWrapper";
import { useQuery } from "@tanstack/react-query";
import httpClient from "../../../../api/module/httpClient";

export default function Orientation({ program }) {

  const classesWithVideos = program?.CourseClasses.filter((item) => {
    return item.videoLink;
  });

  const { data: links } = useQuery({
    queryKey: ["FACULTY_CERTIFICATES_TIPS"],
    queryFn: async () => {
      const { data } = await httpClient.get(`private/certificate/${program?.id}/faculty/links`);

      return data;
    },
    enabled: !!program?.id
  });


  return (
    <div>

      <div>
        <h2>Relevant Permanent Links</h2>
        <ul>
          {(links ?? []).filter(item => item.type === "permanentLink").map((item, index) => {
            return (
              <li
                style={{
                  fontSize: "1rem",
                  cursor: "pointer",
                  color: "#0000EE",
                }}
                onClick={() => {
                  window.open(item.url, "_blank");
                }}
              >
                {item.url}
              </li>
            )
          })}
        </ul>
      </div>
      <div
        // style={{
        //   display: "grid",
        //   gridTemplateColumns: "repeat(3, 1fr)",
        //   gap: "20px",
        //   padding: "2rem"
        // }}
      >
        <div>
          <h1>Documents</h1>
          <div
            style={{

              display: "grid",
              gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
              gap: "20px",
              height: "200px !important",
            }}
          >
            {(links?? []).filter(item => item.type === "document").map(item => {

              return (
                <div style={{ marginTop: "1rem", cursor: "pointer" }}>
                  <div
                    style={{ height: "100%", width: "100%" }}

                    onClick={() => window.open(item.url, "_blank")}
                  >
                    <h3>{item.title}</h3>
                    <img
                      src={item.image}
                      alt={item.title}
                      style={{
                        // width: "100%",
                        // height: "100%",
                        // overFlow: "hidden",
                        border: "2px solid #ccc",
                        borderRadius: "10px",
                        objectFit: "contain",
                      }}
                    />

                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div style={{ marginTop: "1rem", marginBottom: "1rem"}}>
          <h1>Videos</h1>
          <div
            style={{

              display: "grid",
              gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
              gap: "20px",
            }}
          >
            {(links ?? []).filter(item => item.type === "video").map(item => {

              return (
                <div style={{ marginTop: "1rem" }}>
                  <div style={{ height: "100%" }}>
                    <h3>{item.title}</h3>
                    <MicroConferenceVideoWrapper
                      key={item.id} // Add a unique key for each item
                      url={item.url}
                    />

                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  )
}